import _ from 'lodash';
import fecha from 'fecha';
import humanizeDuration from 'humanize-duration';

export const formatPrice = (amount, currency, asFree = false) => {
  if ((!amount && amount !== 0) || !currency) {
    return null;
  }

  if (asFree && amount === 0) {
    return 'FREE';
  }

  //
  // TODO - we support only USD, so we can render everything as en-US locale
  //
  // let locale = 'en-US';
  // if (typeof window === 'object') {
  //   if (navigator?.language) {
  //     const parts = navigator.language.split('-');
  //     if (parts.length > 0) {
  //       const country = parts.length > 1 ? parts[1] : parts[0];
  //       locale = `en-${country}`;
  //     }
  //   }
  // }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(amount);
};

export const formatNumberOfPages = (numberOfPages = 0) => {
  if (numberOfPages > 1) {
    return `${numberOfPages} pages`;
  }
  if (numberOfPages === 1) {
    return '1 page';
  }
  return 'no pages';
};

export const formatDateTime = (dateString, dateFormat = 'YYYY-MM-DD HH:mm:ss Z') => {
  try {
    return fecha.format(fecha.parse(dateString, dateFormat), 'MMM Do, YYYY h:mm a');
  } catch (e) {
    return dateString;
  }
};

export const formatExifDateTime = dateString => {
  try {
    return fecha.format(fecha.parse(dateString, 'YYYY:MM:DD HH:mm:ss'), 'MMM Do, YYYY h:mm a');
  } catch (e) {
    return 'N/A';
  }
};

export const capitalizeString = string => {
  return string
    .split('(')
    .map(part =>
      part
        .split(' ')
        .map(word => {
          const value = _.lowerCase(word);
          if (['my canvas', 'mycanvas'].indexOf(value) >= 0) {
            return 'MyCanvas';
          }
          if (['family search', 'familysearch'].indexOf(value) >= 0) {
            return 'FamilySearch';
          }
          if (['a', 'an', 'of'].indexOf(value) >= 0) {
            return value;
          }
          return _.capitalize(word);
        })
        .join(' '),
    )
    .join('(');
};

export const formatDate = (dateObject, dateFormat = 'YYYY-MM-DD HH:mm:ss Z') => {
  return fecha.format(dateObject, dateFormat);
};

export const parseDate = (dateString, dateFormat = 'YYYY-MM-DD HH:mm:ss Z') => {
  return fecha.parse(dateString, dateFormat);
};

export const formatDuration = (
  startDate,
  endDate = new Date(),
  humanizeDurationOptions = { round: true, largest: 1 },
) => {
  return humanizeDuration(endDate - startDate, humanizeDurationOptions);
};

export const formatSeconds = (seconds) => {
  return humanizeDuration(seconds * 1000, { round: true, largest: 2 });
};
